const initialState = {
  jobValue: [],
  locationValue: [],
  loading: false,
  error: null,
  data: null,
};

export const assignjobReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ASSIGN_JOB_REQUEST":
      return { ...state, loading: true };
    case "FETCH_ASSIGN_JOB_SUCCESS":
      return { ...state, jobValue: action.payload, loading: false };
    case "FETCH_ASSIGN_JOB_FAILURE":
      return { ...state, loading: false };
    default:
      return state; // Always return state
  }
};


export const assignLocationReducer  = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_JOB_LOCATION_REQUEST":
      return {...state,loading: true};
    case "FETCH_JOB_LOCATION_SUCCESS":
      return { ...state, locationValue: action.payload, loading: false };
    case "FETCH_JOB_LOCATION_FAIL":
      return { ...state, loading: false };
    default:
      return state;
  }
};

export const jobAssignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ASSIGN_JOB_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ASSIGN_JOB_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload, // Success data
      };
    case "ASSIGN_JOB_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};